import { EventEmitter } from "../main";

const OBJECT_ID_RE = /^[a-f0-9]{24}$/i;

// В IN_AssignUser веб шлёт в author имя, а iOS и Flutter — id пользователя,
// сервер пересылает поле как есть. Приводим к { id, name }.
function resolveAssignAuthor(author, getters) {
  const me = getters.getUserData;
  if (author === me._id) return { id: me._id, name: me.name };

  if (OBJECT_ID_RE.test(author)) {
    const known = (getters.getKnownUsers || []).find((u) => u._id === author);
    return { id: author, name: known ? known.name : "Someone" };
  }

  return { id: null, name: author || "Someone" };
}

export default function pushNotifications({
  data,
  getters,
  message,
  type = "assign",
  force = true,
}) {
  // console.log(getters.getUserData._id, data.user_id, "push notification");
  if (!force) return;
  if (
    data.user_id !== getters.getUserData._id &&
    !data.hasOwnProperty("priority")
  )
    return;
  if (data.hasOwnProperty("priority") && data.priority !== "High") return;
  const tasks = getters.getTasks;
  let task;
  const projects = Object.values(tasks);
  projects.some((project) => {
    task = project.find((task) => task._id == data.task_id);
    if (task) return true;
  });

  // foreground push notification
  // let showNotification = false;
  // if (!force && window.localStorage.getItem("mutedObjects")) {
  //   let mutedObjects = window.localStorage.getItem("mutedObjects").split(",");
  //   if (!mutedObjects.includes(data.project_id)) {
  //     showNotification = true;
  //   }
  // } else {
  //   showNotification = true;
  // }

  let task_name = "";

  let all_projects = getters.getProjects;
  for (let task in all_projects) {
    if (all_projects[task]._id == data.project_id) {
      task_name = all_projects[task].name;
    }
  }

  let message_settings = {
    body: "",
    dir: "ltr",
    lang: "en-US",
    tag: "chat_" + data._id + "_notification",
    renotify: true,
  };
  console.log(message_settings, "message settings");
  if (!window.isElectronMac) {
    message_settings.icon = "/logo.png";
    message_settings.badge = "/logo.png";
  }
  let play_sound = false;
  if (window.isElectron) {
    message_settings.silent = true;
  } else {
    message_settings.vibrate = [100, 50, 200];
  }

  let new_message = message;

  const author =
    type == "assign"
      ? resolveAssignAuthor(data.author, getters)
      : JSON.parse(data.author);

  new_message = new_message.replace("<Username>", author.name);
  new_message = new_message.replace("<Taskname>", task.name);

  // if (new_message.length > 70) {
  //   new_message = new_message.substring(0, 70)
  // }

  // message_settings.body = task.name

  let message_notification;
  if (true || data.chats.user_name) {
    // console.log('message notification')

    // по id, если он известен: сравнение имён путает тёзок
    const isSelfAssign = author.id
      ? author.id === getters.getUserData._id
      : author.name === getters.getUserData.name;

    if (type == "assign" && isSelfAssign) {
      console.log("silence mode for self assign");
      play_sound = false;
    } else {
      message_notification = new Notification(new_message, message_settings);
      play_sound = true;
    }
  } else {
    play_sound = false;
  }

  if (play_sound) {
    if (!window.electron_dnd) {
      const nSound = new Audio("/sounds/notification.mp3");
      nSound.crossOrigin = "anonymous";
      nSound.play();
    }
  }

  if (message_notification) {
    if (message_notification.onerror) {
      message_notification.onerror = (e) => {
        console.log("Error");
        console.log(e);
      };
    }
    message_notification.onclick = function (event) {
      window.focus();

      event.preventDefault(); // prevent the browser from focusing the Notification's tab
      // if (data.chats.task_id) {
      //   setTimeout(() => {
      //     EventEmitter.$emit(
      //       "open_notification_direction",
      //       "/project/" + data.project_id + "/task/" + data.chats.task_id
      //     );
      //   }, 100);
      // } else {
      //   EventEmitter.$emit(
      //     "open_notification_direction",
      //     "/project/" + data.project_id
      //   );
      // }
      if (type == "assign" || type == "priority") {
        EventEmitter.$emit(
          "openPushNotificationLink",
          `/project/${data.project_id}/task/${data.task_id}`
        );
      }

      if (window.isElectron) {
        window.focusElectron = true;
      }
      setTimeout(() => {
        document.querySelector(".add_comment_block textarea").focus();
      }, 500);
      EventEmitter.$emit("changeSidebarTabs", "Lists");
      EventEmitter.$emit("changeTab", "Lists");
    };
  }
}
